import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import './HomePage.css';

const features = [
    {
        icon: 'fa-calendar-alt',
        title: 'Планирование событий',
        description: 'Создавайте и управляйте планами мероприятий, расписаниями и ролями участников в одном месте.'
    },
    {
        icon: 'fa-music',
        title: 'База песен',
        description: 'Централизованная библиотека для ваших песен с нотами (PDF) и аудиофайлами (MP3).'
    },
    {
        icon: 'fa-globe-americas',
        title: 'Общие фонотеки',
        description: 'Делитесь своей базой песен с другими организациями и используйте их песни в своих мероприятиях.'
    },
    {
        icon: 'fa-users',
        title: 'Совместная работа',
        description: 'Приглашайте коллег в организацию и назначайте им роли в событиях для эффективной командной работы.'
    },
    {
        icon: 'fa-file-pdf',
        title: 'Экспорт в PDF',
        description: 'Генерируйте и скачивайте профессионально оформленные PDF-версии планов ваших событий.'
    },
    {
        icon: 'fa-play-circle',
        title: 'Плеер плейлиста',
        description: 'Прослушивайте все MP3-файлы из плана события в одном удобном плейлисте.'
    }
];

const screenshots = [
    {
        image: '/homepage/event_plan.png',
        alt: 'Скриншот: План события',
        caption: 'Составляйте детальные планы для каждого мероприятия'
    },
    {
        image: '/homepage/song_base.png',
        alt: 'Скриншот: Библиотека песен',
        caption: 'Управляйте централизованной базой песен вашей организации'
    },
    {
        image: '/homepage/song.png',
        alt: 'Скриншот: Страница песни',
        caption: 'Храните ноты, аранжировки и аудиофайлы в одном месте'
    }
];

const HomePage = () => {
    const { user } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedCaption, setSelectedCaption] = useState('');

    const handleShowModal = (image, caption) => {
        if (image) {
            setSelectedImage(image);
            setSelectedCaption(caption);
            setShowModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedImage('');
        setSelectedCaption('');
    };

    return (
        <>
            {/* Hero Section */}
            <Container fluid className="homepage-hero">
                <img src="/logo_white.svg" alt="EventPlan Logo" className="hero-logo" />
                <p className="lead">Планирование без суеты. Служение с вдохновением.</p>
                {!user && (
                    <Button as={Link} to="/register" variant="light" size="lg">Начать работу</Button>
                )}
            </Container>

            {/* Features Section */}
            <Container className="features-section">
                <h2 className="text-center mb-5">Основные возможности</h2>
                <Row>
                    {features.map((feature, index) => (
                        <Col md={6} lg={4} key={index} className="mb-4">
                            <Card className="feature-card text-center">
                                <Card.Body className="p-4">
                                    <div className="feature-icon">
                                        <i className={`fas ${feature.icon}`}></i>
                                    </div>
                                    <Card.Title as="h4" className="mb-3">{feature.title}</Card.Title>
                                    <Card.Text>{feature.description}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Screenshots Section */}
            <div className="screenshots-section">
                <Container>
                    <h2 className="text-center mb-5">Как это выглядит</h2>
                    <Row>
                        {screenshots.map((shot, index) => (
                            <Col md={4} key={index} className="mb-4">
                                <Card className="screenshot-card" onClick={() => handleShowModal(shot.image, shot.caption)} style={{ cursor: shot.image ? 'pointer' : 'default' }}>
                                    {shot.image ? (
                                        <img src={shot.image} alt={shot.alt} className="img-fluid" />
                                    ) : (
                                        <div className="screenshot-placeholder">{shot.placeholder}</div>
                                    )}
                                    <Card.Body>
                                        <p className="mb-0">{shot.caption}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            {/* Image Modal */}
            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedCaption}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={selectedImage} alt={selectedCaption} className="img-fluid" style={{ maxHeight: '80vh', maxWidth: '100%' }} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default HomePage;